import classNames from 'classnames';
import { Link } from 'gatsby';
import React, { ForwardedRef } from 'react';

type Props = {
  center?: boolean;
  color?:
    | 'blue'
    | 'white'
    | 'white-with-blue-border'
    | 'black'
    | 'green'
    | 'green-matte'
    | 'green-gloss'
    | 'red'
    | 'disabled';
  size?: 'small' | 'medium';
  to?: string;
};

type ButtonProps = Props &
  React.ButtonHTMLAttributes<HTMLButtonElement> &
  React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const Button = React.forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  ButtonProps
>(
  (
    {
      center = false,
      color = 'blue',
      size = 'medium',
      children,
      to,
      className,
      ...rest
    },
    ref: ForwardedRef<HTMLButtonElement | HTMLAnchorElement>,
  ): JSX.Element => {
    if (to !== undefined) {
      // This is a link that _looks_ like button.
      // Questionalble, but ok, here we go.

      // External?
      if (to.startsWith('http')) {
        return (
          <a
            ref={ref as ForwardedRef<HTMLAnchorElement>}
            className={classNames(
              'inline-block whitespace-nowrap rounded-full text-center text-base font-bold transition hover:no-underline',
              {
                'px-8 py-3': size === 'medium',
                'px-6 py-2': size === 'small',
                'mx-auto flex justify-center gap-2 md:gap-4': center,
                // prettier-ignore
                'hover:bg-blue-800 blue bg-blue text-blue-50 hover:text-blue-50': color === 'blue',
                // prettier-ignore
                'text-black hover:bg-black-50 bg-white': color === 'white',
                // prettier-ignore
                'text-black shadow-blue-100 hover:shadow-blue-200 box-border shadow-[inset_0px_0px_0px_1px]': color === 'white-with-blue-border',
                // prettier-ignore
                'bg-black hover:bg-black-900 text-white hover:text-white': color === 'black',
                // prettier-ignore
                'bg-success hover:bg-success-600 text-success-50': color === 'green',
                // prettier-ignore
                'bg-error hover:error-600 text-error-50': color === 'red',
                // prettier-ignore
                'bg-black-200 text-black-400 cursor-not-allowed': color === 'disabled',
                // prettier-ignore
                'bg-green-gloss text-green-matte': color === 'green-matte',
                // prettier-ignore
                'bg-green-matte text-green-gloss': color === 'green-gloss',
                [className]: !!className,
              },
            )}
            href={to}
            {...rest}
          >
            {children}
          </a>
        );
      }

      return (
        <Link
          to={to}
          className={classNames(
            'inline-block whitespace-nowrap rounded-full text-center text-base font-bold transition hover:no-underline',
            {
              'px-8 py-3': size === 'medium',
              'px-6 py-2': size === 'small',
              'ap-2 mx-auto flex justify-center md:gap-4': center,
              // prettier-ignore
              'hover:bg-blue-800 blue bg-blue text-blue-50 hover:text-blue-50': color === 'blue',
              // prettier-ignore
              'text-black hover:bg-black-50 bg-white': color === 'white',
              // prettier-ignore
              'text-black shadow-blue-100 hover:shadow-blue-200 box-border shadow-[inset_0px_0px_0px_1px]': color === 'white-with-blue-border',
              // prettier-ignore
              'bg-black hover:bg-black-900 text-white hover:text-white': color === 'black',
              // prettier-ignore
              'bg-success hover:bg-success-600 text-success-50': color === 'green',
              // prettier-ignore
              'bg-error hover:error-600 text-error-50': color === 'red',
              // prettier-ignore
              'bg-black-200 text-black-400 cursor-not-allowed': color === 'disabled',
              // prettier-ignore
              'bg-green-gloss text-green-matte': color === 'green-matte',
              // prettier-ignore
              'bg-green-matte text-green-gloss': color === 'green-gloss',
              [className]: !!className,
            },
          )}
          {...rest}
        >
          {children}
        </Link>
      );
    }

    return (
      <button
        ref={ref as ForwardedRef<HTMLButtonElement>}
        className={classNames(
          'inline-block whitespace-nowrap rounded-full text-center text-base font-bold transition hover:no-underline disabled:cursor-not-allowed',
          {
            'px-8 py-3': size === 'medium',
            'px-6 py-2': size === 'small',
            'mx-auto flex justify-center gap-2 md:gap-4': center,
            // prettier-ignore
            'hover:bg-blue-800 blue bg-blue text-blue-50 hover:text-blue-50': color === 'blue',
            // prettier-ignore
            'text-black hover:bg-black-50 bg-white': color === 'white',
            // prettier-ignore
            'text-black shadow-blue-100 hover:shadow-blue-200 box-border shadow-[inset_0px_0px_0px_1px]': color === 'white-with-blue-border',
            // prettier-ignore
            'bg-black hover:bg-black-900 text-white hover:text-white': color === 'black',
            // prettier-ignore
            'bg-success hover:bg-success-600 text-success-50': color === 'green',
            // prettier-ignore
            'bg-error hover:error-600 text-error-50': color === 'red',
            // prettier-ignore
            'bg-black-200 text-black-400 cursor-not-allowed': color === 'disabled',
            // prettier-ignore
            'bg-green-gloss text-green-matte': color === 'green-matte',
            // prettier-ignore
            'bg-green-matte text-green-gloss': color === 'green-gloss',
            [className]: !!className,
          },
        )}
        {...rest}
      >
        {children}
      </button>
    );
  },
);
